import React from 'react';
import styles from './button.module.scss';
import { APIError } from '../../../../types/api/api';

export type ButtonVariant =
  | 'positive'
  | 'negative'
  | 'icon'
  | 'reset'
  | 'default'
  | 'download'
  | 'outlined';

export type ButtonSize = 'xsmall' | 'small' | 'medium' | 'large' | 'default';

interface ButtonProps extends React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  isError?: APIError | null;
}

const colorPicker = (variant: ButtonVariant): any => {
  switch (variant) {
    case 'positive':
      return styles.buttonPositive;
    case 'negative':
      return styles.buttonNegative;
    case 'icon':
      return styles.icon;
    case 'reset':
      return styles.isReset;
    case 'download':
      return styles.isDownload;
    case 'outlined':
      return styles.buttonOutlined;
    case 'default':
      return '';
  }
};

const sizePicker = (variant: ButtonSize): any => {
  switch (variant) {
    case 'xsmall':
      return styles.xsmall;
    case 'small':
      return styles.small;
    case 'medium':
      return styles.medium;
    case 'large':
      return styles.isReset;
    case 'default':
      return '';
  }
};

const Button: React.FC<ButtonProps> = ({
  variant = 'default',
  size = 'medium',
  children,
  ...props
}) => (
  <button
    className={`${
      variant !== 'default'
        ? `${variant !== 'icon' ? styles.button : ''} ${colorPicker(variant)}`
        : ''
    } ${sizePicker(size)}`}
    {...props}
  >
    {children}
  </button>
);

export default Button;
